export default function updateMigrationTrackingReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_MIGRATION_TRACKING_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_MIGRATION_TRACKING_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_MIGRATION_TRACKING_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}